import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=c2d8f626&scoped=true&"
import script from "./TableLoader.vue?vue&type=script&lang=js&"
export * from "./TableLoader.vue?vue&type=script&lang=js&"
import style0 from "./TableLoader.vue?vue&type=style&index=0&id=c2d8f626&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8f626",
  null
  
)

export default component.exports